import React from 'react';
import { useController } from 'react-hook-form';
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';

// components
import FormFieldError from '../FormFieldError';
import FormFieldLabel from '../FormFieldLabel';
import FormFieldDescription from '../FormFieldDescription';

const DatePickerField = ({ name, control, rules, label, description, placeholder, ...props }) => {
    const wrapperRef = React.useRef(null);
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name,
        control,
        rules
    });

    return (
        <div ref={wrapperRef} className="FormField FormField--datepicker">
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <div className="FormField__datepickerInner">
                <DatePicker
                    value={value}
                    onChange={onChange}
                    id={name}
                    format="dd/MM/yyyy"
                    placeholder={placeholder || 'Select date'}
                    container={() => wrapperRef.current?.closest('dialog') ?? document.body}
                    placement="autoVerticalStart"
                    block
                    {...props}
                />
            </div>
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
};

export default DatePickerField;